import React from 'react';
import { string, bool } from 'prop-types';
import { ComponentPlaceholder } from '@thd-olt-component-react/loading-placeholder';

const EMTPlaceholder = ({ color, showLoadingAnimation }) => {
  return (
    <ComponentPlaceholder
      height={180}
      rows={4}
      color={color}
      showLoadingAnimation={showLoadingAnimation}
    />
  );
};

EMTPlaceholder.propTypes = {
  color: string,
  showLoadingAnimation: bool
};

EMTPlaceholder.defaultProps = {
  color: '#E0E0E0',
  showLoadingAnimation: false
};

export { EMTPlaceholder };
